const theme = require("../styles/theme");

const facebookAppId = "668102933580489";
const facebookPageId = "163420567638989";

const coreTitle = "Manta Equipment";
const titleSeparator = " | ";

const shortDescription = "Intuitive resource management for universities";
const shortCapitalizedDescription = "Intuitive Resource Management for Universities.";
const longDescription = "Manta Equipment tracks and understands how people use your equipment, automating common tasks and making bookings effortless.";

const titles = {
  "/": `${coreTitle}${titleSeparator}${shortCapitalizedDescription}`,
  "/features": `${coreTitle}${titleSeparator}Features`,
  "/plans": `${coreTitle}${titleSeparator}Plans and Pricing`,
  "/privacy": `${coreTitle}${titleSeparator}Privacy Policy`,
  "/faq/accessibility": `${coreTitle}${titleSeparator}Accessibility`,
  "/404": `${coreTitle}${titleSeparator}Page Not Found`,
};

const descriptions = {
  "/": `${shortDescription}. ${longDescription}`,
  "/features": `Simple, but flexible set of features. Track all kinds of resources and understand how they are used.`,
  "/plans": `Custom plans built for your department with features you need. Free demo available upon request.`,
  "/privacy": `Details about what information we collect and how we use it.`,
  "/faq/accessibility": `VPAT and details about accessibility features in Manta.`,
  "/404": `Page not found.`,
};

const facebookMessengerPlatformHTML = `
<div class="fb-customerchat"
 page_id="${facebookPageId}"
 theme_color="${theme.main.colors.ocean}"
 logged_in_greeting="Hey there! Tap below to chat to us on Messenger now."
 logged_out_greeting="Hey there! Tap below to chat to us on Messenger now."
></div>`;

const facebookSDKJS = `
window.fbAsyncInit = function() {
  FB.init({
    appId            : '${facebookAppId}',
    autoLogAppEvents : true,
    xfbml            : true,
    version          : 'v2.12'
  });
};

(function(d, s, id){
   var js, fjs = d.getElementsByTagName(s)[0];
   if (d.getElementById(id)) {return;}
   js = d.createElement(s); js.id = id;
   js.src = "https://connect.facebook.net/en_US/sdk.js";
   fjs.parentNode.insertBefore(js, fjs);
 }(document, 'script', 'facebook-jssdk'));
`;

const matomoJS = `
var _paq = _paq || [];
_paq.push(['trackPageView']);
_paq.push(['enableLinkTracking']);
(function() {
  var u="//olafs.eu/stats/";
  _paq.push(['setTrackerUrl', u+'piwik.php']);
  _paq.push(['setSiteId', '4']);
  var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
  g.type='text/javascript'; g.async=true; g.defer=true; g.src=u+'piwik.js'; s.parentNode.insertBefore(g,s);
})();
`;

const matomoNoScriptHTML = `
<noscript>
  <p>
    <img src="//olafs.eu/stats/piwik.php?idsite=4&rec=1" style="border:0;" alt="" />
  </p>
</noscript>
`;

export default {
  titles,
  descriptions,
  shortDescription,
  longDescription,
  facebookPageId,
  facebookAppId,
  facebookSDKJS,
  facebookMessengerPlatformHTML,
  matomoJS,
  matomoNoScriptHTML
};



// WEBPACK FOOTER //
// ./src/config/index.js